
import { takeEvery, put } from 'redux-saga/effects';

function* _logIn(action) {

    try {
        // Make API call over here 
        yield put({
            type: "UPDATE_NOTIFICATION_COUNT",
            payload: action.payload
        })
    } catch {

    }

}

export function* loginData() {
    yield takeEvery("UPDATE_NOTIFICATION", _logIn)
};